


export const EmailSettings_START = 'EmailSettings_START';
export const EmailSettings_END = 'EmailSettings_END';
export const EmailSettings_ERROR = 'EmailSettings_ERROR';
export const EmailSettings_SUCCESS = 'EmailSettings_SUCCESS';
export const EmailSettings_FAIL = 'EmailSettings_FAIL';
export const IsDataSubmitedSuccessfully ='IsDataSubmitedSuccessfully';